import { sendGAEvent } from '@noths/polaris-client-google-analytics';
import { EventsMap } from '@noths/polaris-client-next-redux';

import { ReduxApplicationState } from 'src/redux/combinedReducer';
import { openDeliveryByEventModal } from '../actions';
import { OpenDeliveryModalEvent } from './events';

export const GAEventsMap: EventsMap<ReduxApplicationState> = {
  [openDeliveryByEventModal.type]: (_, __, action) => {
    const { payload } = action as ReturnType<typeof openDeliveryByEventModal>;

    sendGAEvent<OpenDeliveryModalEvent>({
      event: 'custom_event',
      event_action: 'Open delivery by event modal',
      event_category: 'Delivery & returns',
      event_label: payload,
    });
  },
};
